export interface ExportDeliveryDescriptor {
  status?: string | null;
  destination_type?: string | null;
  destination_connector_id?: string | null;
  download_url?: string | null;
}

export type ExportDeliveryAuthority =
  | 'authenticated_download'
  | 'connector'
  | 'unavailable';

const normalizeExportField = (value: string | null | undefined): string => (
  typeof value === 'string' ? value.trim().toLowerCase() : ''
);

/**
 * Returns the canonical delivery mechanism for an export.
 *
 * `download_url` is intentionally not an authority signal. It is a
 * compatibility response field and may be absent when public token minting is
 * disabled. Completed exports with the canonical `download` destination are
 * always retrieved through the authenticated endpoint. An unresolved
 * destination fails closed until a status response supplies its authority.
 */
export const getExportDeliveryAuthority = (
  exportJob: ExportDeliveryDescriptor,
): ExportDeliveryAuthority => {
  const isConnectorDelivery = (
    normalizeExportField(exportJob.destination_type) === 'connector'
    || normalizeExportField(exportJob.destination_connector_id) !== ''
  );
  if (isConnectorDelivery) {
    return 'connector';
  }

  if (
    normalizeExportField(exportJob.status) === 'completed'
    && normalizeExportField(exportJob.destination_type) === 'download'
  ) {
    return 'authenticated_download';
  }

  return 'unavailable';
};
